import SSOLoginForm from "../components/forms/SSOLoginForm";
import Wrapper from "../components/helpers/Wrapper";

const SSOLoginPage = () => {
    return (
        <Wrapper>
            <div className="grid grid_cols_4 grid_center">
                <div className="grid col_span_2 col_start_2 section_card max_width grid_center h_auto">
                    <SSOLoginForm />
                </div>
            </div>
        </Wrapper >

    )
}
export default SSOLoginPage